import { EMPTY_MUNICIPAL_PROPERTY_CATALOG_FILTER } from "./empty-municipal-property-catalog-filter";
import { MunicipalPropertyCatalogFilter } from "./municipal-property-catalog-filter.model";

export const isMunicipalPropertyCatalogFiltered = (filter: MunicipalPropertyCatalogFilter): boolean =>
  filter.search.trim() !== "" ||
  filter.municipalityId !== null ||
  filter.usage !== EMPTY_MUNICIPAL_PROPERTY_CATALOG_FILTER.usage ||
  filter.lifecycle !== EMPTY_MUNICIPAL_PROPERTY_CATALOG_FILTER.lifecycle;
